import { Icon, InlineExternalLink } from '@monash/portal-react';
import ParkType from '../park-type/ParkType';
import c from './single-carpark.module.scss';
import { SEARCH_TERM_MAP } from '../constants';

export const SingleCarpark = ({ carpark }) => {
  const isCombined = carpark.colour.length > 1;
  const hasLiveData = !(carpark.accessibleSpaces && !isCombined);

  return (
    <>
      <div className={c.wrapper} data-testid="single-carpark">
        <div key={carpark.id} className={c.item}>
          <div className={c.locationName}>
            <b>{carpark.name}</b>
            <a
              className={c.mapLink}
              href={carpark.mapUrl}
              target="_blank"
              rel="noreferrer"
              aria-label={`Map link for ${carpark.name}, ${
                carpark.vacancies
              } ${carpark.colour
                .map((item) => SEARCH_TERM_MAP[item])
                .join(' and ')} available. Opens in a new window.`}
            >
              <Icon.External size={20} color="var(--card-cta-bg-color)" />
            </a>
          </div>
          <div className={c.main}>
            <div className={c.parkTypes}>
              {carpark.colour.map((colour) => {
                const spacesCount =
                  colour === 'Orange' ? carpark.accessibleSpaces : null;
                return (
                  <ParkType
                    key={colour}
                    type={colour}
                    className={c.parkType}
                    spacesCount={spacesCount}
                  />
                );
              })}
            </div>

            {hasLiveData && (
              <span className={c.number}>{carpark.vacancies}</span>
            )}

            <div className={c.subtext}>
              {hasLiveData ? 'available' : 'No live data'}
            </div>
          </div>
        </div>

        <div className={c.links}>
          <InlineExternalLink
            text="More parking information"
            link="https://www.monash.edu/about/our-locations/transport-parking/parking/staff-and-students#tabs__2341855-01"
          />

          <InlineExternalLink
            text="OPark app information"
            link="https://www.monash.edu/about/our-locations/transport-parking/parking/pay-as-you-use"
          />
        </div>
      </div>
    </>
  );
};
